@if (control) {
  <fieldset [attr.id]=" question.id ">
    <legend>
      <div [attr.aria-labelledby]=" question.id +'-err'"></div>
    </legend>
    @let title = text();
    @if (title) {
      <div id="{{ question.id }}-label-content" class="mb-4" [innerHTML]="title"></div>
    }
    @if (controlHasError()) {
      <div class="alert  alert-danger error pill form-error-list">
        <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
          <ul>
            @for (err of baseForm.errorMap.get(question.id!); track err) {
              <li>
                <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    <!-- make sure aria attributes and other are configurable -->
    <div [ngClass]="inputClass" class="container mt-4">
      @for (option of question.orderedAcceptedValues; track $index) {
        <div class="chbx-wrapper mt-2">
          <input #input type="checkbox"
                 class="form-check-input" autocomplete="off"
                 [attr.name]="question.id"
                 name="{{ question.id }}" id="{{ question.id }}-{{ convertWhitespaces(option.value!) }}"
                 [attr.value]="option.key" value="{{ option.key }}"
                 [attr.aria-invalid]="controlHasError()"
                 [formControl]="formArray.controls[$index] | asFormControl"
                 aria-describedby="accept-err"
                 (change)="revalidateInput()"
                 [attr.aria-label]="getLabel()"/>
          <label for="{{question.id}}-{{convertWhitespaces(option.value!)}}"
                 class="field-accept">
            <div class="simple-option-content">{{ displayValue(option.key!, optionCode(option.key!)) }}</div>
          </label>
          @if (!isHoriz() && $last && baseForm.isSubmitted(form) && control.touched) {
            <div #feedback class="feedback-icon form-group radio" aria-hidden="true">
              <i class="fa" aria-hidden="true"
                 [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle' :  controlHasError() }"></i>
            </div>
          }
        </div>
      }
      @if (standalone) {
        <div class="option-row row mt-8 mx-0">
          <div class="px-0 text-end">
            <button class="btn primary rounded-pill confirm-button"
                    [disabled]="baseForm.loading || baseForm.preventSave"
                    [attr.aria-label]="getLabel() + '.confirm_button'"
                    (click)="onEnter($event)"
                    (keydown.enter)="onEnter($event)">
              @if (baseForm.loading) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              {{ messages.getText('WILL.button.save-and-continue') }}
            </button>
          </div>
        </div>
      }
    </div>
  </fieldset>
}
<ng-content></ng-content>
